import api from "./index.js";
//获取岗亭首页数据
export function homePageInfo() {
  return api.get("/park/home/homePageInfo");
}

//设备开闸
export function openGate(data) {
  return api.post("/park/openGate", data);
}

//设备关闸
export function closeGate(data) {
  return api.post("/park/closeGate", data);
}

//获取车位信息
export function space() {
  return api.get("/park/home/space");
}

//获取车位信息边缘系统
export function spaceEdge() {
  return api.get("/park/web/edgeServerParkGarage/list");
}

//修改车位信息边缘系统
export function editEdge(data) {
  return api.post("/park/web/edgeServerParkGarage/editServerGarage", data);
}

//修改车位信息
export function edit(data) {
  return api.post("/park/home/space/edit", data);
}

//获取开闸原因
export function openGateRes() {
  return api.get("/park/home/openGate/reason");
}
// 自定义开闸原因
export function openCause() {
  return api.post("/park/web/openCause/pageList", {
    pageNum: 1,
    pageSize: 100,
  });
}
//获取关闸闸原因
export function closeGateRes() {
  return api.get("/park/home/closeGate/reason");
}

//获取免费放行原因
export function freePassRes() {
  return api.get("/park/home/freePass/reason");
}
//退出云岗亭

export function logout() {
  return api.delete("/auth/logout");
}

// 开闸、关闸、常开
export function openCloseGateServer(data) {
  return api({
    url: "/park/server/command/open",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function bindDevicesw(data) {
  return api({
    url: "/park/web/honeycomb/device/bind",
    method: "post",
    data,
  });
}

export function unbindDevicesw(data) {
  return api({
    url: "/park/web/honeycomb/device/unbind",
    method: "post",
    data,
  });
}

export function getDeviceInfosw(data) {
  return api({
    url: "/park/web/honeycomb/device/info",
    method: "post",
    data,
  });
}

export function getDeviceWebUrlsw(data) {
  return api({
    url: "/park/web/honeycomb/device/remoteWebUrl",
    method: "post",
    data,
  });
}

export function getDeviceVideoHeart(data) {
  return api({
    url: "/park/web/honeycomb/device/videoHeart",
    method: "post",
    data,
  });
}
// /web/honeycomb/device/accessKey 获取设备accessKey
export function getDeviceAccessKey(data) {
  return api({
    url: "/park/web/honeycomb/device/accessKey",
    method: "post",
    data,
  });
}

export function getDeviceVideoSw(data) {
  return api({
    url: "/park/web/honeycomb/device/playAddress",
    method: "post",
    data,
  });
}

// 获取边缘系统车辆列表
export function getEdgeServerCarList(data) {
  return api({
    url: "/park/web/edgeServerCar/list",
    method: "post",
    data,
  });
}

export function getParkParamConfig() {
  return api({
    url: "/park/web/park/getParamConfig",
    method: "get",
  });
}